export default "__VITE_ASSET__CTSdXCFH__"